import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Inbox, Map, Landmark } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import DemandesTab from "@/components/admin/DemandesTab";
import ProspectsTab from "@/components/admin/ProspectsTab";
import AnnuaireTab from "@/components/admin/AnnuaireTab";

const TABS = [
  { id: "demandes", label: "Demandes de concert", icon: Inbox, testid: "admin-tab-demandes" },
  { id: "prospection", label: "Prospection collectivités", icon: Map, testid: "admin-tab-prospection" },
  { id: "annuaire", label: "Annuaire mairies", icon: Landmark, testid: "admin-tab-annuaire" },
];

export default function Admin() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("demandes");

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <main data-testid="admin-dashboard-route" className="min-h-screen bg-[#09090D] text-zinc-100">
      <header className="border-b border-amber-500/15 bg-[#161622]/60 backdrop-blur-md sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Logo size={36} />
            <span className="hidden sm:block text-xs font-jbmono uppercase tracking-[0.25em] text-amber-400 border-l border-zinc-800 pl-4">
              Back-office
            </span>
          </div>
          <div className="flex items-center gap-4">
            <span data-testid="admin-user-email" className="hidden md:block text-xs text-zinc-500 font-jbmono">
              {user?.email}
            </span>
            <button
              data-testid="admin-logout-button"
              onClick={handleLogout}
              className="flex items-center gap-2 text-xs font-jbmono uppercase tracking-wider text-zinc-400 hover:text-red-400 border border-zinc-700 hover:border-red-500/40 rounded-full px-4 py-2 transition-colors duration-300"
            >
              <LogOut size={13} />
              Déconnexion
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8">
        <div className="flex flex-wrap gap-2 mb-8">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={t.testid}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2.5 text-sm font-semibold rounded-full px-5 py-2.5 border transition-colors duration-300 ${
                tab === t.id
                  ? "bg-amber-500 text-white border-amber-500"
                  : "border-zinc-800 text-zinc-400 hover:text-amber-400 hover:border-amber-500/40 bg-[#161622]"
              }`}
            >
              <t.icon size={15} />
              {t.label}
            </button>
          ))}
        </div>

        {tab === "demandes" ? <DemandesTab /> : tab === "prospection" ? <ProspectsTab /> : <AnnuaireTab />}
      </div>
    </main>
  );
}
